import { ContentBlockType, LessonState, TargetJoint } from "./constants";

// Plain dict keyed by locale code. Lessons store one row per locale on the
// backend; there's no canonical "primary" string baked into the shape.
export type LocalizedText = Partial<Record<string, string>>;

// ----- Form-facing types (multi-locale friendly) -----

export type LocalizedContentBlock = {
  type: ContentBlockType;
  // For image blocks the string is a URL; same shape as text blocks.
  content: LocalizedText;
};

export type LocalizedAnswer = {
  correct: boolean;
  text: LocalizedText;
};

export type LocalizedQuestion = {
  id?: number;
  title: LocalizedText;
  tipDescription: LocalizedText;
  answers: LocalizedAnswer[];
};

export type PartFormData = {
  id?: number;
  // translation id per locale code (so we can PUT vs POST on save)
  translationIds?: Partial<Record<string, number>>;
  title: LocalizedText;
  imageUrl: LocalizedText;
  content: LocalizedContentBlock[];
  questions: LocalizedQuestion[];
};

export type LessonFormData = {
  id?: number;
  state: LessonState;
  target_joints: TargetJoint[];
  creator_id?: number | null;
  parts: PartFormData[];
};

export const emptyLocalizedText = (): LocalizedText => ({});

export const emptyPart = (): PartFormData => ({
  title: emptyLocalizedText(),
  imageUrl: emptyLocalizedText(),
  content: [],
  questions: [],
});
